// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_PlM","cls2":"AccountMenuButton-cls2_fyt AccountMenuButton-cls1_PlM"};